module.exports = "/_next/static/images/96a7b48c1498a5785b266869ec157a57-sanpablo-3-desktop.jpg.webp";